import React from 'react';
// components
import { Logo } from 'src/components/reusable/Logo';
import Container from 'src/components/reusable/Container';
import { H4 } from 'src/components/reusable/Typography';
import UserDropdown from './UserDropdown';
import { UnstyledLink } from 'src/components/reusable/Links';
import { PATH_DASHBOARD } from 'src/routes/path';

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <header className="relative py-6 border-b border-[#F3F7FF] h-24">
      <Container>
        <div className="flex relative justify-between items-center text-center">
          <div className="flex-1">
            <UnstyledLink href={PATH_DASHBOARD.general.send_gift_card}>
              <Logo className="w-20 md:w-auto" />
            </UnstyledLink>
          </div>
          {title && (
            <div className="flex-1">
              <H4 className="text-base sm:text-2xl"> {title}</H4>
            </div>
          )}
          <div className="flex-1">
            <UserDropdown />
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
